


































import Vue from 'vue';
import Component from 'vue-class-component';

import { Meta, MetaInfo } from '@/decorators';

import { Link } from '@/types';

import { mdiArrowLeft } from '@mdi/js';

interface LinkItem {
	title: string;
	links: Link[];
}

/** About page */
@Component({
	components: {
		LinksList: () => import(
			/* webpackChunkName: "links-list" */
			'@/components/LinksList'
		)
	}
})
export default class About extends Vue {
	backArrowIcon = mdiArrowLeft;

	get links(): LinkItem[] {
		return this.$t('views.about.links') as unknown as LinkItem[];
	}

	/* istanbul ignore next */
	@Meta
	metaInfo(): MetaInfo {
		return {
			title: this.$t('views.about.meta.title') as string,
			meta: [
				{
					name: 'description',
					vmid: 'description',
					content: this.$t('views.about.meta.description') as string
				}
			]
		};
	}
}
